export default __webpack_public_path__ + "static/media/single-project-page-01-img6.a3189c5a.jpg";